var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte",
    transform: "translate(-1375.000000, -256.000000)",
    stroke: "#AFAFB1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1105.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(48.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Searchbar-Copy-2",
    transform: "translate(0.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Serarch-Icon",
    transform: "translate(223.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-(7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.64705882,
    cy: 5.64705882,
    r: 5.64705882
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5411765,15.5411765 L10.3529412,10.3529412",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3d006d711229bf465ae311a477c4dabd.svg";
export { ForwardRef as ReactComponent };